export default __webpack_public_path__ + "static/media/01.9f9d35c0.jpg";